package sd.gov.moe.lp.admin.utils.views.filters

import com.narbase.kunafa.core.components.View
import com.narbase.kunafa.core.components.verticalLayout
import com.narbase.letsgo.web.theme.theme
import com.narbase.letsgo.web.utils.views.RemoteDropDownList
import com.narbase.letsgo.web.utils.views.filters.FiltersView
import com.narbase.letsgo.web.utils.views.matchParentWidth
import com.narbase.letsgo.web.utils.views.setupDropDownList

/*
 * NARBASE TECHNOLOGIES CONFIDENTIAL
 * ______________________________
 * [2017] -[2019] Narbase Technologies
 * All Rights Reserved.
 * Created by islam
 * On: 2024/07/27.
 */
open class DropListFilter<FilterValue>(
        private val title: String,
        private val selectedFilterShortTitle: String,
        private val listValues: Array<FilterValue>,
        private val defaultValue: FilterValue?,
        private val valueToString: (FilterValue) -> String,
        private val onItemSelected: (FilterValue?) -> Unit,
        private val showAutoComplete:Boolean = true,
) : FiltersView.FilterType<FilterValue>() {

    private var dropDownList: RemoteDropDownList<FilterValue>? = null
    var selectedFilterValue: FilterValue? = null

    override fun View?.getView(): View = verticalLayout {
        matchParentWidth()
        theme.label(this, title, isRequired = false)
        dropDownList = setupDropDownList(
                title,
                getList = { pageNo, _, searchTerm ->
                    if (pageNo != 0) return@setupDropDownList arrayOf()
                    val filterValues = listValues.filter { (it.toString()+ valueToString(it)).contains(searchTerm, ignoreCase = true) }.toTypedArray()
                    return@setupDropDownList filterValues
                },
                itemToString = valueToString,
                defaultItem = defaultValue,
                onItemSelected = {
                    selectedFilterValue = it
                    onItemSelected(it)
                    filterParent.onFilterUpdated()
                },
            showAutoComplete = showAutoComplete
        )
    }


    override fun onFilterCleared() {
        dropDownList?.clear()
    }

    override fun getFilterValueAsString(): String? {
        return selectedFilterValue?.let { "$selectedFilterShortTitle: ${valueToString(it)}" }
    }
}